import React, { useContext } from "react";
import {
  Typography,
  Skeleton,
  CardActionArea,
  CardContent,
  Box,
  Button,
} from "@mui/material";
import { AtticusForm } from "../../models/AtticusForm";
import { FormThumbnail } from "./FormThumbnail";
import Chip from "@mui/material/Chip";
import AtticusFormUpgradeToViewDialog from "./dialog/AtticusFormUpgradeToViewDialog";
import AtticusFormViewDialog from "./dialog/AtticusFormViewDialog";
import { PdfFileChoice } from "./dialog/useAtticusFormViewer";
import { useAuthContext } from "AuthContextWrapper"
import { GeographyJson } from "models/Geography";

interface Props {
  form: null | AtticusForm;
  percentMatch: number;
  formGeography: null | GeographyJson;
}

const FeaturedFormCard = ({
  form,
  percentMatch,
  formGeography,
}: Props): JSX.Element => {
  const [open, setDialogOpen] = React.useState<boolean>(false);
  const { subscription } = useAuthContext()

  return form ? (
    <>
      {subscription?.isActive ? (
        <AtticusFormViewDialog
          open={open}
          onClose={() => setDialogOpen(false)}
          form={form}
          fileChoice={PdfFileChoice.PROCESSED}
          withDisclaimer
        />
      ) : (
        <AtticusFormUpgradeToViewDialog
          open={open}
          onClose={() => setDialogOpen(false)}
          form={form}
        />
      )}
      <CardActionArea
        component={Button}
        onClick={() => {
          setDialogOpen(true);
        }}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          clear: "both",
        }}
      >
        <>
          <Chip
            size={"small"}
            color="secondary"
            style={{
              position: "absolute",
              float: "right",
              marginRight: "-40%",
              marginTop: "1rem",
              zIndex: 50,
            }}
            label={Math.floor(percentMatch * 100).toString() + "% match"}
          />
          <Box
            sx={{
              pt: "1.3rem",
              pb: "1.3rem",
              pl: "3.6rem",
              pr: "3.6rem",
              backgroundColor: "#F2F2FF",
              width: "100%",
              height: "150px",
            }}
          >
            <FormThumbnail
              form={form}
              sx={{ width: "100%", height: "100%" }}
              onClick={null}
            />
          </Box>
          <CardContent
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <div style={{ height: "75px" }}>
                <Typography
                  component="p"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    wordBreak: "break-word",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                    minHeight: "25px",
                  }}
                >
                  {form.title.atticus || form.title.original}
                </Typography>
                <Typography
                  gutterBottom
                  component="p"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    wordBreak: "break-all",
                    display: "-webkit-box",
                    WebkitLineClamp: "1",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {formGeography?.code
                    ? formGeography.code.toUpperCase() + " | "
                    : ""}
                  {form.governmentId || ""}
                </Typography>
              </div>
              <Typography
                variant="body1"
                component="p"
                style={{
                  height: "20px",
                  color: "#6F79D4",
                }}
              >
                View
              </Typography>
            </Box>
          </CardContent>
        </>
      </CardActionArea>
    </>
  ) : (
    <Box>
      <Box sx={{ padding: "1rem", backgroundColor: "#F2F2FF", width: "100%" }}>
        <Skeleton
          variant="rectangular"
          sx={{ width: "170px", height: "240px" }}
        />
      </Box>
    </Box>
  );
};

export default FeaturedFormCard;
